<template>
  <Navbar pageName="sk" />
  <template v-if="isMobile">
    <MobileBanner :bannerList="mobileBannerList" />
    <MobileContent />
    <MobileFooter />
  </template>
  <template v-else>
    <DesktopBanner :bannerList="pcBannerList" />
    <DesktopContent />
    <Feature />
    <DesktopFooter />
  </template>
</template>

<script>
import DesktopBanner from '@/shared/components/banner/desktop-banner'
import DesktopFooter from '@/shared/components/footer/desktop-footer.vue'
import Feature from '@/shared/components/feature.vue'
import MobileBanner from '@/shared/components/banner/mobile-banner.vue'
import MobileFooter from '@/shared/components/footer/mobile-footer.vue'
import Navbar from '@/shared/components/navbar.vue'

import DesktopContent from './component/content/desktop-content.vue'
import MobileContent from './component/content/mobile-content.vue'

import { isMobile } from '@/shared/utils/equipment.utils.js'

export default {
  components: {
    DesktopBanner,
    DesktopFooter,
    Feature,
    Navbar,
    MobileBanner,
    MobileFooter,

    DesktopContent,
    MobileContent,
  },
  setup() {
    const pcBannerList = ['./images/sk-banner.png', './images/index-banner1.png']
    const mobileBannerList = ['./images/mobile/sk-banner.png', './images/mobile/index-banner1.png']
    return { pcBannerList, mobileBannerList, isMobile: isMobile() }
  },
}
</script>
